import React, { createContext, useContext, useState } from 'react';
import { LoginUser } from '../Helpers/requests';
import { useSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCallback } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';

/*Custom hook - used to enque notifications, returns function:
  @param: message - Message to display in notification
  @variant: variant of message to display: default, success, error, warning and info
  @note: Has custom Close icon to dismiss messages
*/
function DisplayNotification() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const returnFunc = useCallback(
    (message, variant = 'success') => {
      enqueueSnackbar(message, {
        variant,
        action: (key) => (
          <>
            <IconButton
              onClick={() => {
                closeSnackbar(key);
              }}
            >
              <CloseIcon fontSize='small' sx={{ color: 'white' }} />
            </IconButton>
          </>
        ),
      });
    },
    [enqueueSnackbar, closeSnackbar]
  );

  return returnFunc;
}

function NavigateBlock() {
  const nav = useNavigate();
  const returnFunc = useCallback(
    (location, element) => {
      if (element === true) {
        return <Navigate to={location} replace />;
      } else {
        nav(location, { replace: true });
      }
    },
    [nav]
  );
  return returnFunc;
}

const AuthData = new createContext(null);
export default function AuthProvider({ children }) {
  const [userPermissions, SetUserPermissions] = useState({});
  const Notification = DisplayNotification();
  const SignIn = (username, password, callback) => {
    LoginUser(username, password, callback);
  };

  const setPermissions = (permissions) => {
    SetUserPermissions(permissions);
  };
  const navigateTo = NavigateBlock();

  const signOut = (callback = () => {}) => {
    localStorage.removeItem('JWT_Key');
    navigateTo('/login', false);
    callback();
  };

  return (
    <AuthData.Provider
      value={{
        userPermissions,
        SignIn,
        signOut,
        Notification,
        setPermissions,
        navigateTo,
      }}
    >
      {children}
    </AuthData.Provider>
  );
}

export function GetAuth() {
  return useContext(AuthData);
}
